/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import FromToPicker from '../BaseComponent/FromToPicker'
import {grid, gridColumn} from '@progress/kendo-react-excel-export'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'

class FirstDeliveryPack extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      printInfo: [],
      pageNumber: 1,
      buttonClicked: false,
      list: [],
      fromDate: '',
      toDate: '',
      fromPrintDate: '',
      toPrintDate: '',
      customerCode: '',
      fromRegDate: '',
      toRegDate: '',
      pageSize: 10,
      countAll: 0,
      sortBy: 'planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه پارت تحویل ',
          value: 'deliveryPackId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ تحویل',
          value: 'planDate',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'بازه تحویل',
          value: 'bazeTahvil',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'شماره فاکتور',
          value: 'invoiceNum',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: ' خریدار',
          value: 'buyerName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تحویل گیرنده',
          value: 'recipientName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'موبایل',
          value: 'mobile',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت پرداخت',
          value: 'paid',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پرداخت در محل',
          value: 'payOnDelivery',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  getReport = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_FIRSTDELIVERYPACK}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            list: response.data.object.result,
            countAll: response.data.object.countAll,
            buttonClicked: true,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            list: [],
            countAll: 0,
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
  }

  onResultFetched(data) {
    this.setState({
      list: data
    })
  }

  changeDropDown(data) {
    this.setState({
      list: data,
      lengthProducts: this.state.countAll
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleChangeFromRegDate = (fromRegDate) => {
    this.setState({
      fromRegDate
    })
  }

  handleChangeToRegDate = (toRegDate) => {
    this.setState({
      toRegDate
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let fromRegDate = this.state.fromRegDate
    let toRegDate = this.state.toRegDate
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let buyerName = document.getElementById('buyerName').value.trim()
    let recipientName = document.getElementById('recipientName').value.trim()
    let paid = document.getElementById('paid').value
    let confirmed = document.getElementById('confirmed').value
    let canceled = document.getElementById('canceled').value
    let payOnDelivery = document.getElementById('payOnDelivery').value

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (minDate !== '') {
      filter.planDateMin = minDate
    }

    if (maxDate !== '') {
      filter.planDateMax = maxDate
    }
    if (fromRegDate !== '') {
      filter.registerDateMin = fromRegDate
    }
    if (toRegDate !== '') {
      filter.registerDateMax = toRegDate
    }
    if (invoiceNum !== '') {
      filter.invoiceNum = invoiceNum
    }
    if (invoiceId !== '' && invoiceId.length) {
      filter.invoiceId = invoiceId
    }

    if (buyerName !== '' && buyerName.length) {
      filter.buyerName = buyerName
    }

    if (recipientName !== '' && recipientName.length) {
      filter.recipientName = recipientName
    }
    if (paid !== '' && paid.length) {
      filter.paid = paid
    }
    if (confirmed !== '' && confirmed.length) {
      filter.confirmed = confirmed
    }
    if (canceled !== '' && canceled.length) {
      filter.canceled = canceled
    }
    if (payOnDelivery !== '' && payOnDelivery.length) {
      filter.payOnDelivery = payOnDelivery
    }
    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_FIRSTDELIVERYPACK}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            lengthRemains: response.data.object.countAll,
            loading: false
          })

          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
          // message.error(response.data.description)
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {})
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_FIRSTDELIVERYPACK}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)

            if (excelReport[i].invoice['mobile'] == null) {
              excelReport[i].invoice['mobile'] = '-'
            } else {
              excelReport[i].invoice['mobile'] = excelReport[i].invoice['mobile'].replace(/\+98/g, '0')
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i].invoice['paid'] = 'پرداخت شده'
            } else {
              excelReport[i].invoice['paid'] = 'پرداخت نشده'
            }

            if (excelReport[i].invoice['canceled']) {
              excelReport[i].invoice['canceled'] = 'کنسل شده'
            } else {
              excelReport[i].invoice['canceled'] = 'کنسل نشده'
            }

            if (excelReport[i].invoice['confirmed']) {
              excelReport[i].invoice['confirmed'] = 'تایید شده'
            } else {
              excelReport[i].invoice['confirmed'] = 'تایید نشده'
            }

            if (excelReport[i].invoice['payOnDelivery']) {
              excelReport[i].invoice['payOnDelivery'] = 'بله'
            } else {
              excelReport[i].invoice['payOnDelivery'] = 'خیر'
            }
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let columns = [
      'ردیف',
      'تاریخ تحویل',
      'بازه تحویل',
      'شناسه فاکتور',
      'شماره فاکتور',
      ' خریدار',
      'تحویل گیرنده',
      'موبایل',
      'وضعیت پرداخت',
      'پرداخت در محل'
    ]
    let params = sessionStorage.getItem('params')
    let name = cookie.load('name')

    let excelColumns = [
      {title: 'کد محصول', value: 'articleId'},
      {title: 'بارکد محصول', value: 'productCode'},
      {title: 'نام محصول', value: 'productName'},
      {title: 'نام انبار', value: 'warehouseName'},
      {title: 'نام تامین کننده', value: 'providerName'}
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="اولین پارت تحویل مشتریان جدید"
              headerColSpan={10}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={5}
              centerColSpan={1}
              centerSection={''}
              rightSection={'تاریخ تحویل از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((items, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                  <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                  <td>{items.invoice.invoiceId}</td>
                  <td>{items.invoice.invoiceNum}</td>
                  <td>{items.invoice.buyerName}</td>
                  <td>{items.invoice.recipientName}</td>
                  <td className="mobileTD">
                    {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                  </td>
                  <td>{items.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                  <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'اولین پارت تحویل مشتریان جدید : ' + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'نام خریدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recipientName'}
                field={'invoice.recipientName'}
                title={'تحویل گیرنده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mobile'}
                field={'invoice.mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'paid'}
                field={'invoice.paid'}
                title={'وضعیت پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'confirmed'}
                field={'invoice.confirmed'}
                title={'وضعیت تایید'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'canceled'}
                field={'invoice.canceled'}
                title={'وضعیت کنسل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payOnDelivery'}
                field={'invoice.payOnDelivery'}
                title={'پرداخت در محل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>خرید و فروش</li>
            <li>اولین پارت تحویل مشتریان جدید</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid
                  getPageSize={this.getPageSize}
                  createLink={'/report/purchase/firstDeliveryPack'}
                  enablePageSize
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تحویل از"
                  toLabel="تاریخ تحویل تا"
                  defaulValue
                  fromId="from"
                  toId="to"
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromRegDate}
                  onChangeToDate={this.handleChangeToRegDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  defaulValue={false}
                  fromId="fromReg"
                  toId="toReg"
                />
                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceId" name="invoiceId" />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <label>نام خریدار (در فاکتور) :</label>
                  <input type="text" className="form-control" id="buyerName" name="buyerName" />
                </div>

                <div className="formComponent">
                  <label>نام تحویل گیرنده (در فاکتور) :</label>
                  <input type="text" className="form-control" id="recipientName" name="recipientName" />
                </div>
                <div className="formComponent">
                  <label>وضعیت تایید :</label>
                  <select className="form-control" id="confirmed" name="confirmed">
                    <option value="">-------</option>
                    <option selected={true} value={1}>
                      تایید شده
                    </option>
                    <option value={0}>تایید نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت کنسل :</label>
                  <select className="form-control" id="canceled" name="canceled">
                    <option value="">-------</option>
                    <option value={1}>کنسل شده</option>
                    <option selected={true} value={0}>
                      کنسل نشده
                    </option>
                  </select>
                </div>
                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="paid" name="paid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.list.map((items, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>
                        <Link
                          to={{
                            pathname: '/baskets',
                            search: `?deliveryPackId=${items.deliveryPackId}`
                          }}
                          target={'_blank'}
                        >
                          {items.deliveryPackId}
                        </Link>
                      </td>
                      <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                      <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                      <td>{items.invoice.invoiceId}</td>
                      <td>{items.invoice.invoiceNum}</td>
                      <td>{items.invoice.buyerName}</td>
                      <td>{items.invoice.recipientName}</td>
                      <td className="mobileTD">
                        {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                      </td>
                      <td>{items.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                      <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FirstDeliveryPack
